{
  "church": {
    "nave": {
      "u0": -26,
      "u1": 8,
      "v0": 38,
      "v1": 52,
      "eaves": 12,
      "ridge": 18.3
    },
    "choir": {
      "u0": 8,
      "chordU": 22,
      "vc": 45,
      "half": 5.2,
      "eaveY": 10.8,
      "ridgeY": 16.2
    },
    "naveWoodcutPixel": [1390, 2525],
    "choirWoodcutPixel": [1325, 2550],
    "note": "Separate forechurch and choir follow the period mass hierarchy and Bilhamer’s later plan. All metre dimensions, heights and openings are fitted estimates."
  },
  "ranges": [
    {
      "id": "south-range",
      "u0": -8.7,
      "u1": 33.7,
      "v0": 1.3,
      "v1": 10,
      "alongU": true,
      "eaves": 6.8,
      "ridge": 11.2,
      "frontSide": 2,
      "front": [
        [33.7, 10],
        [-8.7, 10]
      ],
      "woodcutPixel": [1320, 2440]
    },
    {
      "id": "west-range",
      "u0": -8.7,
      "u1": 0,
      "v0": 10,
      "v1": 35.8,
      "alongU": false,
      "eaves": 6,
      "ridge": 10.4,
      "frontSide": 1,
      "front": [
        [0, 10],
        [0, 35.8]
      ],
      "woodcutPixel": [1360, 2450]
    },
    {
      "id": "east-range",
      "u0": 25,
      "u1": 33.7,
      "v0": 10,
      "v1": 38,
      "alongU": false,
      "eaves": 8,
      "ridge": 12.7,
      "frontSide": 3,
      "front": [
        [25, 38],
        [25, 10]
      ],
      "woodcutPixel": [1255, 2480]
    }
  ],
  "rooms": [
    {
      "id": "refectory",
      "u0": -8.7,
      "u1": 5.3,
      "v0": 1.3,
      "v1": 7.8
    },
    {
      "id": "wine-cellar-range",
      "u0": 8,
      "u1": 14.5,
      "v0": 1.3,
      "v1": 7.8
    },
    {
      "id": "south-unassigned",
      "u0": 14.5,
      "u1": 33.7,
      "v0": 1.3,
      "v1": 7.8
    },
    {
      "id": "west-south",
      "u0": -8.7,
      "u1": -2.2,
      "v0": 10,
      "v1": 21.5
    },
    {
      "id": "west-north",
      "u0": -8.7,
      "u1": -2.2,
      "v0": 24.3,
      "v1": 35.8
    },
    {
      "id": "east-unassigned",
      "u0": 27.2,
      "u1": 33.7,
      "v0": 10,
      "v1": 38
    }
  ],
  "walks": [
    {
      "u0": -8.7,
      "u1": 33.7,
      "v0": 7.8,
      "v1": 10
    },
    {
      "u0": -2.2,
      "u1": 0,
      "v0": 10,
      "v1": 35.8
    },
    {
      "u0": 25,
      "u1": 27.2,
      "v0": 10,
      "v1": 38
    },
    {
      "u0": 0,
      "u1": 25,
      "v0": 35.8,
      "v1": 38
    }
  ],
  "northWalk": {
    "u0": 0,
    "u1": 25,
    "v0": 35.8,
    "v1": 38,
    "front": [
      [0, 35.8],
      [25, 35.8]
    ]
  },
  "court": {
    "u0": 0,
    "u1": 25,
    "v0": 10,
    "v1": 35.8
  },
  "entry": {
    "u0": -28.3,
    "u1": 0,
    "v0": 21.5,
    "v1": 24.3
  },
  "orchard": {
    "u0": -26,
    "u1": 26,
    "v0": -36,
    "v1": -10,
    "columns": 8,
    "rows": 4
  },
  "beds": {
    "u0": 35,
    "u1": 56,
    "v0": -57,
    "v1": -10,
    "columns": 3,
    "rows": 6
  },
  "cemetery": {
    "u0": -26,
    "u1": -9.2,
    "v0": -2,
    "v1": 37
  },
  "note": "Veerkamp’s excavation account supports the approximately 2.2 m walks, 14 by 6.5 m refectory and 6.5 m square cellar beside a passage. Their fitted placement, outer range heights/roofs, northern walk, garden divisions, entrances and trees remain estimates. No later gate modifications or post-1578 public street/house grid is copied. The full vanished annex programme remains unresolved.",
  "walls": [
    {
      "id": "west-garden-and-cemetery",
      "from": [-27.8, -39.3],
      "to": [-27.8, 20.9],
      "width": 0.35,
      "height": 1.85
    },
    {
      "id": "west-cemetery-above-entry",
      "from": [-27.8, 24.9],
      "to": [-27.8, 37.7],
      "width": 0.35,
      "height": 1.85
    },
    {
      "id": "south-orchard",
      "from": [-27.8, -39.3],
      "to": [30.6, -39.3],
      "width": 0.35,
      "height": 1.85
    },
    {
      "id": "east-orchard-division",
      "from": [30.6, -39.3],
      "to": [30.6, -8.5],
      "width": 0.35,
      "height": 1.85
    },
    {
      "id": "north-orchard-west",
      "from": [-27.8, -8.5],
      "to": [5.1, -8.5],
      "width": 0.35,
      "height": 1.85
    },
    {
      "id": "north-orchard-east",
      "from": [8.2, -8.5],
      "to": [30.6, -8.5],
      "width": 0.35,
      "height": 1.85
    }
  ],
  "enclosureNote": "The painting and woodcut show garden/cemetery enclosure and planted-ground divisions. These straight wall runs fit the retained precinct and garden edges; exact alignment, 0.35 m thickness, 1.85 m height and the two open accesses are estimates. The orchard opening lines up with the existing refectory/cellar passage. The east city-wall side, vanished annexes and complete cemetery programme remain unresolved; no Bilhamer-era gate alterations are backdated. The graded garden approach through the refectory/cellar passage is also an estimate.",
  "gardenEntry": {
    "u0": 5.3,
    "u1": 8,
    "v0": -10,
    "v1": 7.8
  }
}
